import { render, staticRenderFns } from "./FacebookBulkUpdate.vue?vue&type=template&id=2a64518e&lang=pug"
import script from "./FacebookBulkUpdate.vue?vue&type=script&lang=js"
export * from "./FacebookBulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./FacebookBulkUpdate.vue?vue&type=style&index=0&id=2a64518e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports